<div class="parentcontainer">
  <!-- Left Navigation Panel -->
  <div class="sidebar" *ngIf="isExpanded">
    <div class="group-header">
      <label for="from" class="groupLabel">Group Name: </label>
      <p-dropdown
        [styleClass]="'custom-dropdown  drop-down group-details-inp drop-admin greyed-when-inactive'"
        optionLabel="name"
        class=""
        [(ngModel)]="selectedGroup"
        name="selectedGroup"
        (onChange)="groupChangesForInit()"
        [options]="selectedGroupList"
        [autofocus]="false"
        [autofocusFilter]="false"
        [filter]="true"
        filterPlaceholder="Search"
        showTransitionOptions="0ms"
        hideTransitionOptions="0ms"
      >
      </p-dropdown>
    </div>
    <ul class="menu">
      <li
        *ngFor="let option of groupOptions; let isLast = last"
        class="menu-item"
        (click)="setActiveGroupOption(option)"
      >
        <div class="menu-title-wrap">
          <div
            [ngClass]="{
              'activeOption': option.title === activeGroupOption,
              'notActiveOption': option.title != activeGroupOption,
            }"
          ></div>
          <span
            [ngClass]="{
            'active-menu-text': option.title === activeGroupOption,
            'menu-text': option.title != activeGroupOption,
          }"
            >{{ option.title }}</span
          >
        </div>

        <div class="iconWrap">
          <!-- *ngIf="option.title != activeGroupOption" -->
          <div  *ngIf="option.title != activeGroupOption" class="completeIcon" >
            <img src="assets/Inbox/greencheckbox.svg" alt="Open side panel" />
          </div>
          <div  *ngIf="option.title == activeGroupOption" class="completeIcon">
            <img src="assets/Inbox/bluecheckbox.svg" alt="Open side panel" />
          </div>
          <div class="divider" *ngIf="!isLast"></div>
        </div>
      </li>
    </ul>
    <div  (click)="changeExpand(option)" class="sidebarExpandButton"  pTooltip="Collapse"
      tooltipPosition="left"
      tooltipStyleClass="leftTooltip p-tooltip-text">
      <img src="assets/Inbox/sidebarExpand.svg" alt="collapse" />
    </div>
  </div>
  <div *ngIf="!isExpanded"   class="sidebarCollapsed">
    <div (click)="changeExpand(option)" class="sidebarCollapsedButton"  pTooltip="Expand"
      tooltipPosition="left"
      tooltipStyleClass="leftTooltip p-tooltip-text">
      <img src="assets/Inbox/sidebarCollapsed.svg" alt="Expand" />
    </div>
  </div>

  <!-- Right Panel Placeholder -->
  <div class="content" *ngIf="testLoad">
    <div  class="detail-view-loading">
      <div class="detail-view-container-with-sidebar" style='margin-right: 15px;'>
          <ng-template #customLoadingTemplate>
              <div class="custom-class-loader-mail-detail-view">
                  <div class="spinner-container">
                      <img src="assets/qwyn/icons/spinner.gif" alt="Loading" class="loader">
                  </div>
              </div>
          </ng-template>
          <ngx-loading [show]="testLoad"
              [config]="{ backdropBorderRadius: '3px',fullScreenBackdrop:false }"
              [template]="customLoadingTemplate"></ngx-loading>
      </div>
    </div>
  </div>
  <div class="content" *ngIf="!testLoad">

      <!-- Group Details starts here -->
    <div class="metadataContainer" *ngIf="activeGroupOption==='Group Details'">
      <div style="padding: 34px; padding-top: 40px;">
        <p class="group-details-header mb-5">
          Please select a Group Manager at a L7 or L8 level to ensure that all reporting is captured accurately for this Group DL.
        </p>

        <div class="groupSelectContainer" style="flex-direction: row;">
          <div class="groupContainerDiv">
            <label for="from" class="groupManagerLabel">Group Manager: </label>
            <div>
              <div class="d-flex justify-content-start">
                <input type="text" [(ngModel)]="groupManager" #groupManagerId [ngModelOptions]="{standalone: true}"
                  (input)="onGroupManagerInputChange()"
                  placeholder="Search..." class="w-50 search-box" />
                <em class="search-icon fa fa-search" (click)="callLookupService(true)"></em>
                <span *ngIf="validationFlag"
                    style="color: red; font-size: 14px; padding-top:10px; margin-left: 21px;  font-style: italic">{{validationMsg}}
                      The user id entered is not valid. </span>
              <span *ngIf="this.isLookupClicked && showBlankValidation()"
                    style="color: red;font-size: 14px;padding-top:10px; margin-left: 21px;  font-style: italic">{{blankStringValidationMsg}}
              </span>
              </div>
            </div>
          </div>
          <div class="groupContainerDiv">
            <div class="d-flex justify-content-start">
                <div class="groupDetailsIcon">
                  <img src="assets/Inbox/Group_Union.svg"/>
                </div>
                <div class="groupDetailsTextTip">
                  Tip:
                </div>
                <div class="groupDetailsText">
                  Appoint a more junior team member so we can map the levels up from the global directory.
                </div>
            </div>
          </div>
        </div>

        <div class="groupSelectContainer flex flex-row">
          <div  class="groupContainerDiv">
            <p class="groupManagerLabel mb-0">Send Inquiry As: </p>
            <div>
              <div class="d-flex justify-content-start preference-radio preferenceRadio ps-0">
                <div *ngFor="let sendInquiry of sendInquirys" class="d-flex flex-row mt-1" style="width: 188px;">
                  <p-radioButton
                    [inputId]="sendInquiry.key"
                    name="sendInquiry"
                    [value]="sendInquiry"
                    class="group-radio-margin-left"
                    [(ngModel)]="selectedSendInquiry"
                  ></p-radioButton>
                  <label class="group-radio-label" [for]="sendInquiry.key">{{sendInquiry.name}}</label>
                </div>
              </div>
            </div>
          </div>
          <div style="flex-direction: row; display: flex;">
            <div class="d-flex justify-content-start" style="margin-top: 25px; margin-left: -50px;">
                <div class="groupDetailsIcon">
                  <img src="assets/Inbox/Group_Union.svg"/>
                </div>
                <div class="groupDetailsTextTip">
                    Tip:
                </div>
                <div class="groupDetailsText">
                    This selection is for the display name. If user name selected, example Jane Doe will display as the sender. If group is selected, the group name will display as the sender. In both cases reply messages will go to the group DL.
                </div>
            </div>
          </div>
        </div>


      <div class="grouplevelContainer">
          <div class="groupTableHeader">
            <label for="from" class="groupTableHeaderLabel">Manager Hierarchy</label>
            <div class="mangerLevelContainer">
              <div class="groupmanagercontainerWrapper">
                <label for="from" class="groupManagerLevelLabel">Level 1:</label>
                <div class="groupManagerTextWrapper">
                  <label class="groupmanagerText">{{heirarchyData?.firstLevelHeirarchy[0]?.userName}}</label>
                </div>
              </div>
              <div class="groupmanagercontainerWrapper">
                <label for="from" class="groupManagerLevelLabel">Level 2:</label>
                <div class="groupManagerTextWrapper">
                  <label class="groupmanagerText">{{heirarchyData?.secondLevelHeirarchy[0]?.userName}}</label>
                </div>
              </div>
              <div class="groupmanagercontainerWrapper">
                <label for="from" class="groupManagerLevelLabel">Level 3:</label>
                <div class="groupManagerTextWrapper">
                  <label class="groupmanagerText">{{heirarchyData?.thirdLevelHeirarchy[0]?.userName}}</label>
                </div>
              </div>
            </div>
          </div>
            <div class="w-100">
              <div class="groupTableHeader">
                <label for="from" class="groupTableHeaderLabel">Managed Segment</label>
                <div class="mangerLevelContainer">
                  <div class="groupmanagercontainerWrapper">
                    <label for="from" class="groupManagerLevelLabel">Level 1:</label>
                    <div class="groupManagerTextWrapper">
                      <label class="groupmanagerText"></label>
                    </div>
                  </div>
                  <div class="groupmanagercontainerWrapper">
                    <label for="from" class="groupManagerLevelLabel">Level 2:</label>
                    <div class="groupManagerTextWrapper">
                    <label class="groupmanagerText"></label>
                    </div>
                  </div>
                  <div class="groupmanagercontainerWrapper">
                    <label for="from" class="groupManagerLevelLabel">Level 3:</label>
                    <div class="groupManagerTextWrapper">
                      <label class="groupmanagerText"></label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
      </div>

     </div>
     <div class="mg-level-metadata-footer">
        <button pButton label="Undo" class="cancel-button" (click)="resetForm()"></button>
        <button pButton label="Save" class="submit-button" (click)="saveGroupDetails()"></button>
     </div>

    </div>
    <!-- Group Details ends here -->

      <!-- Metadata starts here -->
      <div class="metadataContainer" *ngIf="activeGroupOption==='Metadata'">
<!--          <div class="infoArea">
              <div class="infoDescBox" *ngIf="metadataInfo">
                  <div>
                      <img src="assets/Inbox/groupAdminInfo.svg" alt="Add" />
                  </div>
                  <div class="infoText">
                      Displays currently selected Group DL's inquiry related details. <strong>Request Type, Root Cause</strong> and <strong>Processing Region</strong> can be added/edited in this sections.
                  </div>
                  <div (click)="toggleMetaDataInfo()">
                      <img src="assets/Inbox/groupAdminClose.svg" alt="Close" />
                  </div>
              </div>
          </div>-->
          <div class="infoArea">
              <div class="infoDescBox" *ngIf="metadataInfo">
                  <div>
                      <img src="assets/Inbox/groupAdminInfo.svg" alt="Add" />
                  </div>
                  <div class="infoText" [innerHTML]="infoMetadata">
                  </div>
                  <div
                      (click)="toggleMetaDataInfo()"
                      pTooltip="Close"
                      tooltipPosition="left"
                      tooltipStyleClass="leftTooltip p-tooltip-text">
                      <img src="assets/Inbox/groupAdminClose.svg" alt="Add" />
                  </div>
              </div>
              <div
                  *ngIf="!metadataInfo"
                  class="infoIcon"
                  (click)="toggleMetaDataInfo()">
                  <img src="assets/Inbox/groupAdminInfo.svg" alt="Add" />
              </div>
          </div>
          <div class="metadataSelectContainer">
              <label for="from" class="metadataLabel">Metadata type: </label>
              <div class="w-100">
                  <div class="d-flex justify-content-start">
                      <p-dropdown
                              [styleClass]="'standardDropdownStyle drop-down group-details-inp drop-admin'"
                              [options]="metadataTypeList"
                              placeholder="Select Metadata Type"
                              [(ngModel)]="selectedMetaDataType"
                              name="selectedMetaDataType"
                              (onChange)="selectMetaDataType($event.value,'onchange')"
                              [ngClass]="{'standardDropdownStyle-open': isDropdownOpen}" (onShow)="isDropdownOpen = true"
                    (onHide)="isDropdownOpen = false">

                      </p-dropdown>
                  </div>
              </div>
          </div>
          <div *ngIf="metaDataType === 'Tags'" class="metadata-mandatory">
              <div class="d-flex justify-content-start">
                  <input type="checkbox" class="metadata-mandatory-checkbox" name="tag" value="tagMandatory" [(ngModel)]="isTagMandatory">
                  <div class="metadata-mandatory-label">Make mandatory for resolve</div>
              </div>
          </div>
          <div *ngIf="metaDataType === 'Root Cause'" class="metadata-mandatory">
              <div class="d-flex justify-content-start">
                  <input type="checkbox" class="metadata-mandatory-checkbox" name="rootCause" value="rootCauseMandatory" [(ngModel)]="isRootCauseMandatory">
                  <div class="metadata-mandatory-label">Make mandatory for resolve</div>
              </div>
          </div>

          <div *ngIf="metaDataType !== 'Root Cause' && metaDataType !== 'Tags'" style="height: 17px;"></div>

          <div class="d-flex flex-column" *ngIf="metaDataType !== 'reqTypeCauseMapping' && metaDataType !== ''">
              <div class="metadataHeader">
                  <div class="add-new-btn" (click)="onBtStartEditing(null, null, 'top')">
                      <span class="add-new-button"> + Add New</span>
                  </div>
                  <div class="buttonDivider" [hidden]="metaDeleteFlag"></div>
                  <span [hidden]="metaDeleteFlag">
                    <div class="delete-button" (click)="setConfirmation('metaData')">
                      <img class="delete-icon" src="assets/Inbox/peerreviewDelete.svg" alt="Delete"/>
                      <span>Delete</span>
                    </div>
                </span>
              </div>
          </div>
          <div id="domain" class="peerReviewTable" *ngIf="metaDataType !== 'reqTypeCauseMapping' && metaDataType !== ''">
              <ag-grid-angular
                  #agDomain
                  style="width: 100%;"
                  id="adminMetadata"
                  class="ag-theme-balham peerTable inquiryTable"
                  [columnDefs]="metaColumnDefs"
                  [rowData]="metaRowData"
                  [stopEditingWhenCellsLoseFocus]="true"
                  [singleClickEdit]="true"
                  [suppressRowClickSelection]="true"
                  [defaultColDef]="metaCheckbox"
                  (gridReady)="onMetaDataGridReady($event)"
                  (cellValueChanged)="onCellValueChanged($event)"
                  [rowSelection]="rowSelection"
                  (selectionChanged)="onSelectionCheck()"
                  (cellKeyDown)="onkeydown($event)"
                  [rowHeight]="32"
                  [headerHeight]="40"
                  [suppressHorizontalScroll]="true"
                  [popupParent]="document.body"
                  domLayout="autoHeight"
              ></ag-grid-angular>
          </div>
          <div *ngIf="metaDataType === 'reqTypeCauseMapping' && metaDataType !== ''" class="d-flex flex-column">
              <!-- <div [ngClass]="{'disabled':disableAddMetaDataOption}"> commenting it to see request to root cause mapping if org disable group level metadata-->
              <app-reqtype-rootcause
                      [requestTypes]='groupRequestTypes'
                      [requestCauses]='groupRootCauses'
                      [reqTypeRootCauseList]="reqTypeRootCauseMap"
                      (updateMapping)="onApplyMapping($event)">
              </app-reqtype-rootcause>
              <!-- </div> -->
          </div>
          <div *ngIf="metaDataType !== 'reqTypeCauseMapping' && metaDataType !== ''" class="metadata-footer">
              <button pButton label="Undo" class="cancel-button" (click)="resetForm()"></button>
              <button pButton label="Save" class="submit-button" (click)="saveGroup()"></button>
          </div>
          <div *ngIf="metaRowData.length === 0" class="noPeerReview">
              <img src="assets/Inbox/peerReviewGradient.svg" alt="Info" />
              <div class="noPeerReviewTextBox">
                  <div class="noPeerReviewText">No metadata setup yet</div>
                  <div class="noPeerReviewText">
                      Please select a metadata type to add to your group.
                  </div>
              </div>
          </div>
      </div>
      <!-- Metadata ends here -->
      <!-- User Entitlements starts here -->
      <div class="entitlement-container" *ngIf="activeGroupOption === 'User Entitlements'">

          <div class="infoArea" style="height: 50px;">
              <div class="infoDescBox" *ngIf="entitlementInfo">
                  <div>
                      <img src="assets/Inbox/groupAdminInfo.svg" alt="Info" />
                  </div>
                  <div class="infoText" [innerHTML]="infoEntitlement">
                  </div>
                  <div
                          (click)="toggleEntitlementInfo()"
                          pTooltip="Close"
                          tooltipPosition="left"
                          tooltipStyleClass="leftTooltip p-tooltip-text">
                      <img src="assets/Inbox/groupAdminClose.svg" alt="Add" />
                  </div>
              </div>
              <div
                      *ngIf="!entitlementInfo"
                      class="infoIcon"
                      (click)="toggleEntitlementInfo()">
                  <img src="assets/Inbox/groupAdminInfo.svg" alt="Add" />
              </div>
          </div>
          <div style="padding: 30px; padding-top: 10px;">
              <div class="d-flex flex-row" style="margin: 0 0 0 16px">
                  <div class="d-flex flex-row align-items-center input-holder my-2">

                      <div (click)="onEntitlementUserChange(1)" class="entitlement-tab-heading"
                           [class.active]="tabArray[1]">
                          <span>Add New Users</span>
                          <div class="tab-indicator"></div>
                      </div>

                      <div (click)="onEntitlementUserChange(0)" class="entitlement-tab-heading"
                           [class.active]="tabArray[0]">
                          <span>Manage Users</span>
                          <div class="tab-indicator"></div>
                      </div>
                  </div>
              </div>
              <div *ngIf="tabArray[1]" class="secondView" style="margin-left: 16px; margin-top: 31px;">
                  <div class="d-flex flex-row">
                      <label for="from" class="search-label">Search | Add Users:</label>
                      <input type="text"
                             [(ngModel)]="newUserSoeid"
                             name="newUserSoeid"
                             (keydown)="keyDownFunction($event)"
                             placeholder="Search User ID"
                             class="search-box"/>
                      <div class="download-section">
                          <button class="download-button"
                                  (click)="isDownloadOpen = !isDownloadOpen"
                                  [class.active]="isDownloadOpen">
                              <span>Download Form</span>
                              <img *ngIf="!isDownloadOpen"
                                   src="../../../assets/qwyn/icons/download_down_arrow.svg"
                                   alt="Download"
                                   class="arrow-icon"
                                   (click)="$event.stopPropagation()"/>
                              <img *ngIf="isDownloadOpen"
                                   src="../../../assets/qwyn/icons/download_up_arrow.svg"
                                   alt="Download"
                                   class="arrow-icon"
                                   (click)="$event.stopPropagation()"/>
                          </button>

                          <div class="download-options" *ngIf="isDownloadOpen">
                              <div class="option" (click)="downloadForm('csv')">CSV</div>
                              <div class="option" (click)="downloadForm('xls')">XLS</div>
                              <div class="option" (click)="downloadForm('xlsx')">XLSX</div>
                          </div>
                      </div>
                  </div>
                  <div style="margin-top: 1em !important; font-family: OpenSans">
              <span *ngIf="userEntitlementFlag" style="color: red;">{{entitlementValidationMsg}}
              </span></div>
                  <div style="margin-top: 1em !important; font-family: OpenSans">
              <span *ngIf="newUserSoeIdValidationFlag"
                    style="color: red;">{{blankStringValidationMsg}} </span>
                  </div>
                  <div id="users" [hidden]="newUserGridFlag" class="entitlement-outer-table">
                      <div class="d-flex flex-row" [hidden]="entitleAddUserDelAndGropFlag" style="justify-content:right; padding-right:3px; padding-left:0px; padding-bottom:9px;">
                          <div class="actions-container">
                              <button class="add-to-group-button" (click)="showAddtoGrpPanel($event, addToGrp)">
                                  + Add to group
                              </button>
                              <div class="vertical-divider"></div>
                              <div class="delete-container">
                        <span class="add-to-group-delete" (click)="setConfirmation('newUserEntitlement')">
                            <span class="icon-wrapper">
                                <img class="delete-icon" src="assets/qwyn/icons/entitlement_delete.svg" alt="Delete">
                            </span>
                            Delete
                        </span>
                              </div>
                          </div>
                          <div style="position:relative;" class="d-flex flex-row">
                              <p-overlayPanel [styleClass]="'add-to-group-panel'" [appendTo]="'body'"
                                              #addToGrp [baseZIndex]="9999">
                                  <div class="d-flex flex-row mb-0.3">
                                      <app-checkbox-list [placeholder]="'Search'" [name]="'groups'"
                                                         [items]="entGrpName" [listStyle]="{'height':'158px'}"
                                                         [scroll]="scroll" (onItemSelect)="getAssignedGroups($event)">
                                      </app-checkbox-list>
                                  </div>
                                  <div class="d-flex flex-row mb-0.3"
                                       style="text-align:center;padding:5px;margin-top:20px;">
                              <span class="flex-row flex-nowrap align-items-end w-135"
                                    style="width:100%;">
                                  <button type="submit" class="btn search-submit-button"
                                          (click)="entitleNewAggGroup($event,addToGrp)">Submit</button>
                              </span>
                                  </div>
                              </p-overlayPanel>
                          </div>
                      </div>
                      <div class="d-flex flex-row flex-wrap" *ngIf="entitleAddUserDelAndGropFlag" style="padding-bottom:39px;">
                      </div>
                      <div style="width: 100%;">
                          <ag-grid-angular
                              #agAddNewData
                              style="width: 100%;"
                              class="ag-theme-balham entitlement-table"
                              [rowData]="addNewUserData"
                              [rowSelection]="'multiple'"
                              [columnDefs]="addNewUserColumns"
                              [stopEditingWhenCellsLoseFocus]="true"
                              [defaultColDef]="entitleColDef"
                              [singleClickEdit]="true"
                              [suppressRowClickSelection]="true"
                              (selectionChanged)="onAddNewUserSelectionChanged($event)"
                              (cellValueChanged)="onEntitlementCellValueChanged($event)"
                              (cellEditingStopped)="onCellEditingStopped($event)"
                              (gridReady)="onAddNewDataGridReady($event)"
                              [rowHeight]="32"
                              [headerHeight]="40"
                              [suppressHorizontalScroll]="true"
                              [modules]="modules"
                              domLayout="autoHeight">
                          </ag-grid-angular>
                      </div>
                  </div>
                  <div *ngIf="newUserGridFlag" class="d-flex flex-row">
                      <div class="d-flex flex-row align-items-center upload-container">
                          <label for="from" class="search-label"></label>
                          <div class="upload-section"
                               [class.drag-over]="isDragOver"
                               tabindex="0"
                               (dragover)="$event.preventDefault()"
                               (dragleave)="$event.preventDefault()"
                               (drop)="fileDragEventForEntitlement($event)">
                              <div class="icon-container">
                                  <img src="assets/qwyn/icons/upload_icon.svg" alt="upload icon"/>
                              </div>
                              <div class="text-primary">
                                  Choose a file or drag & drop it here
                              </div>
                              <div class="text-secondary">
                                  Download the Bulk Upload from in order to submit a Bulk upload request
                              </div>
                              <div class="button-container">
                                  <button class="upload-button" (click)="upload_csv()">
                                      Upload File
                                  </button>
                              </div>
                              <input name="files" id="files" type="file" multiple="false" style="display:none"
                                     #uploadFiles (change)="fileEvent($event)" accept=".xlsx, .xls, .csv" />
                          </div>
                      </div>
                  </div>
                  <div *ngIf="!newUserGridFlag" class="entitlement-footer">
                      <button pButton label="Cancel" class="cancel-button" (click)="resetForm()"></button>
                      <button pButton label="Save" class="submit-button" (click)="saveGroup()"></button>
                  </div>
              </div>

              <div *ngIf="!tabArray[1]" class="firstView" style="margin-left: 28px;">
                  <div [hidden]="entitleDelAndGropFlag">

                      <div class="d-flex flex-row" style="justify-content:right; padding-right:3px; padding-left:0px; padding-bottom:9px;">
                          <div class="actions-container">
                              <button class="add-to-group-button" (click)="showAddtoGrpPanel($event, addToGrp)">
                                  + Add to group
                              </button>
                              <div class="vertical-divider"></div>
                              <div class="delete-container">
                        <span class="add-to-group-delete" (click)="setConfirmation('userEntitlement')">
                            <span class="icon-wrapper">
                                <img class="delete-icon" src="assets/qwyn/icons/entitlement_delete.svg" alt="Delete">
                            </span>
                            Delete
                        </span>
                              </div>
                          </div>
                          <div style="position:relative;" class="d-flex flex-row">
                              <p-overlayPanel [styleClass]="'add-to-group-panel'" [appendTo]="'body'"
                                              #addToGrp [baseZIndex]="9999">
                                  <div class="d-flex flex-row mb-0.3">
                                      <app-checkbox-list [placeholder]="'Search'" [name]="'groups'"
                                                         [items]="entGrpName" [listStyle]="{'height':'158px'}"
                                                         [scroll]="scroll" (onItemSelect)="getAssignedGroups($event)">
                                      </app-checkbox-list>
                                  </div>
                                  <div class="d-flex flex-row mb-0.3"
                                       style="text-align:center;padding:5px;margin-top:20px;">
                              <span class="flex-row flex-nowrap align-items-end w-135"
                                    style="width:100%;">
                                  <button type="submit" class="btn search-submit-button"
                                          (click)="entitleAggGroup($event,addToGrp)">Submit</button>
                              </span>
                                  </div>
                              </p-overlayPanel>
                          </div>
                      </div>
                  </div>
                  <div class="d-flex flex-row flex-wrap" *ngIf="entitleDelAndGropFlag" style="padding-bottom:39px;">
                  </div>
                  <div style="width: 100%;">
                      <ag-grid-angular class="ag-theme-balham entitlement-table"
                           id="userEntitlement"
                           [rowSelection]="'multiple'"
                           [rowData]="entitleData"
                           [columnDefs]="entitleColumns"
                           [stopEditingWhenCellsLoseFocus]="true"
                           [defaultColDef]="entitleColDef"
                           [singleClickEdit]="true"
                           (selectionChanged)="onSelectionChanged($event)"
                           (cellValueChanged)="onEntitlementCellValueChanged($event)"
                           (cellEditingStopped)="onCellEditingStopped($event)"
                           (gridReady)="onEntitleGridReady($event)"
                           suppressPaginationPanel="true"
                           suppressMenu="true"
                           [rowHeight]="32"
                           [headerHeight]="40"
                           [suppressHorizontalScroll]="true"
                           (paginationChanged)="onEntitlementPaginationChanged()"
                           [pagination]="true"
                           [paginationPageSize]="12"
                           [paginationAutoPageSize]="false"
                           [modules]="modules"
                           domLayout="autoHeight">
                      </ag-grid-angular>
                  </div>
                  <div
                          style="height:40px!important"
                          class="inquiryRulesTableBottom qma-mailbox-pagination-container">
                      <div class="d-flex align-items-center">
                              <span>
                                <img
                                        [ngClass]="{'pagination-img-disabled':disablePaginationPrevFirstEntitlement}"
                                        (click)="onBtFirstEntitlement()"
                                        id="btFirstEntitlement"
                                        class="pagination-img"
                                        src="assets/Inbox/lineLeftButton.svg"
                                        alt="First"
                                        style="margin-right: 10px;"/>
                              </span>
                          <span class="separator-right">
                                <img
                                        id="btPreviousEntitlement"
                                        [ngClass]="{'pagination-img-disabled':disablePaginationPrevFirstEntitlement}"
                                        (click)="onBtPreviousEntitlement()"
                                        class="pagination-img"
                                        src="assets/Inbox/leftButton.svg"
                                        alt="Previous"
                                />
                              </span>
                          <span
                                  id="lbCurrentPageEntitlement"
                                  class="separator-right pagination-text-padding inquiryPageNo">
                                  {{lbCurrentPageEntitlement}}
                              </span>
                          <span class="separator-right pagination-text-padding" style="margin-right: 4px;">of</span>
                          <span
                                  id="lbTotalPagesEntitlement"
                                  class="separator-right pagination-text-padding">
                                  {{lbTotalPagesEntitlement}}
                              </span>
                          <span>
                                <img
                                        [ngClass]="{'pagination-img-disabled':disablePaginationNextLastEntitlement}"
                                        id="btNextEntitlement"
                                        (click)="onBtNextEntitlement()"
                                        class="pagination-img"
                                        src="assets/Inbox/rightButton.svg"
                                        alt="Next"
                                        style="margin-right: 10px;margin-left: 14px;"/>
                              </span>
                          <span class="separator-right">
                                <img
                                        [ngClass]="{'pagination-img-disabled':disablePaginationNextLastEntitlement}"
                                        id="btLastEntitlement"
                                        (click)="onBtLastEntitlement()"
                                        class="pagination-img"
                                        src="assets/Inbox/lineRightButton.svg"
                                        alt="Last"/>
                              </span>
                      </div>

                      <div class="d-flex align-items-center">
                              <span
                                      class="value inquiryRuleTableRulesCountNo"
                                      id="lbPageSizeEntitlement"
                              >{{lbPageSizeEntitlement}}
                              </span>
                          <span
                                  class="separator inquiryRuleTableRulesCount"
                                  style="margin-left: 4px;">
                                of
                              </span>
                          <span
                                  class="value separator inquiryRuleTableRulesCount"
                                  id="lbTotalRecordsEntitlement"
                                  style="margin-left: 4px;">
                                  {{lbTotalRecordsEntitlement}}
                              </span>
                          <span
                                  class="separator separator-right inquiryRuleTableRulesCount"
                                  style="margin-left: 4px;">
                                Users
                              </span>
                      </div>
                  </div>
                  <div class="entitlement-footer">
                      <button pButton label="Cancel" class="cancel-button" (click)="resetForm()"></button>
                      <button pButton label="Save" class="submit-button" (click)="saveGroup()"></button>
                  </div>
              </div>
          </div>
          <p-dialog [(visible)]="isGroupAdmin" [modal]="true" [responsive]="true" [maximizable]="false"
                    [appendTo]="'body'" [styleClass]="'success-modal'" [closable]="true"
                    [dismissableMask]="true" [baseZIndex]="10000" [closeOnEscape]="true" [style]="{width: '25%'}">
              <p-header [style]="{'height': '48px', 'background-color': '#1C1A32'}">
                  <div class="d-flex flex-row align-items-center justify-content-between">
                      <h6>
                          {{ errorMessageForGroupAdmin && errorMessageForGroupAdmin.toLowerCase().includes('success')
                          ? 'Success Confirmation'
                          : 'Error Message' }}
                      </h6>
                  </div>
              </p-header>
              <div class="success-msg">{{errorMessageForGroupAdmin}}</div>
          </p-dialog>
      </div>
      <!-- User Entitlements ends here -->
      <!-- Escalation Criteria starts here -->
      <div *ngIf="activeGroupOption==='Escalation Criteria'" class="preferenceContainer">
          <div class="preferenceInputContainer" style="padding-top:50px;">
              <label for="from" class="escalationLabel" style="font-weight:700; margin:0px;">Conversation Count Threshold:</label>
              <input type="text" pKeyFilter="int"
                     [(ngModel)]="converThreshold"
                     name="converThreshold"
                     class="escalationInput"
                     placeholder="Type here"
                     (keydown)=onEnterNumber($event) />
          </div>
          <div class="preferenceInputContainer" style="padding-top:20px;">
              <label for="from" class="escalationLabel" style="font-weight:700; margin:0px;">Response Time Threshold:</label>
              <div style="gap:0px; display:flex; flex-direction: row;">
                  <input type="number" pKeyFilter="int"
                         [(ngModel)]="resTimeThreHr"
                         name="resTimeThreHr"
                         class="escalationInput"
                         style="width:80px; margin:0px;"
                         placeholder="00"
                         (keydown)=onEnterNumber($event) />
                  <label for="from" class="escalationLabel" style="width:80px; margin:0px;">hrs</label>
                  <input type="number" pKeyFilter="int"
                         [(ngModel)]="resTimeThreMin"
                         name="resTimeThreMin"
                         class="escalationInput"
                         style="width:80px; margin:0px;"
                         placeholder="00"
                         (keydown)=onEnterNumber($event) />
                  <label for="from" class="escalationLabel" style="width:80px; margin:0px;">min</label>
              </div>
          </div>
          <div class="preferenceInputContainer" style="padding-top:20px;">
              <label for="from" class="escalationLabel" style="font-weight:700; margin:0px;">Pending Approval Threshold:</label>
              <div style="gap:0px; display:flex; flex-direction: row;">
                  <input type="number" pKeyFilter="int"
                         [(ngModel)]="penApprThreHr"
                         name='penApprThreHr'
                         class="escalationInput"
                         style="width:80px; margin:0px;"
                         placeholder="00"
                         (keydown)=onEnterNumber($event) />
                  <label for="from" class="escalationLabel" style="width:80px; margin:0px;">hrs</label>
                  <input type="number" pKeyFilter="int"
                         [(ngModel)]="penApprThreMin"
                         name='penApprThreMin'
                         class="escalationInput"
                         style="width:80px; margin:0px;"
                         placeholder="00"
                         (keydown)=onEnterNumber($event) />
                  <label for="from" class="escalationLabel" style="width:80px; margin:0px;">min</label>
              </div>
          </div>
          <div class="metadata-footer">
              <button pButton label="Undo" class="cancel-button" (click)="resetForm()"></button>
              <button pButton label="Save" class="submit-button" (click)="saveGroup()"></button>
          </div>
      </div>
      <!-- Escalation Criteria ends here -->

    <!-- preference starts here -->
    <div *ngIf="activeGroupOption==='Preferences'" class="preferenceContainer">
      <div class="preferenceInfo">
        <div class="infoDescBox" *ngIf="metadataInfo">
          <div>
              <img src="assets/Inbox/groupAdminInfo.svg" alt="Add" />
          </div>
          <div class="infoText" [innerHTML]="infoPreferences">
          </div>
          <div
              (click)="toggleMetaDataInfo()"
              pTooltip="Close"
              tooltipPosition="left"
              tooltipStyleClass="leftTooltip p-tooltip-text">
              <img src="assets/Inbox/groupAdminClose.svg" alt="Add" />
          </div>
        </div>
        <div
            *ngIf="!metadataInfo"
            class="infoIcon"
            (click)="toggleMetaDataInfo()">
            <img src="assets/Inbox/groupAdminInfo.svg" alt="Add" />
        </div>
      </div>
      <div class="preferenceInputContainer">
        <label for="from" class=" preferenceLabel ">Peer review email</label>
        <div class="preferenceswitch">
          <p-inputSwitch
            [(ngModel)]="makerCheckerRqd"
            name="makerCheckerRqd"
            (onChange)="enablePeerReview()"
            [styleClass]="'advance-inputSwitch'"
          ></p-inputSwitch>
        </div>
      </div>
      <div class=" preference-radio preferenceRadio">
        <div class="flex-row flex-nowrap " [hidden]="enablePeerReviewDiv">
          <div class="d-flex flex-row">
            <p-radioButton
              class="radioButtonStyle"
              value="All"
              label="All emails to external clients"
              [(ngModel)]="peerRevDomain"
              name="peerRevDomain"
            ></p-radioButton>
          </div>
          <div class="d-flex flex-row">
            <p-radioButton
              value="Attachments"
              class="radioButtonStyle"
              label="Emails to external clients with attachments/images only"
              [(ngModel)]="peerRevDomain"
              name="peerRevDomain"
            ></p-radioButton>
          </div>
        </div>
      </div>
      <div
        *ngIf="isAutoAssignmentRollOutOrgs"
        class="preferenceInputContainer ms-4"
      >
        <label for="from" class=" preferenceLabel"
          >Enable Auto Assignment
        </label>
        <div class="preferenceswitch">
          <p-inputSwitch
            [(ngModel)]="enableAutoAssignment"
            name="enableAutoAssignment"
            [styleClass]="'advance-inputSwitch'"
          ></p-inputSwitch>
        </div>
      </div>
      <div
        *ngIf="isAutoAssignmentRollOutOrgs"
        class="preferenceInputContainer ms-4"
      >
        <label for="from" class=" preferenceLabel"
          >Enable Trade Status Suggestion
        </label>
        <div class="preferenceswitch">
          <p-inputSwitch
            [(ngModel)]="enableAutoReplySuggestion"
            name="enableAutoReplySuggestion"
            [styleClass]="'advance-inputSwitch'"
            (ngModelChange)="onAutoReplyToggle($event)"
          ></p-inputSwitch>
        </div>
      </div>
      <div class="preferenceInputContainer">
        <label for="from" class="preferenceLabel"
          >Enable Predictive Recipients
        </label>
        <div class="preferenceswitch">
          <p-inputSwitch
            [(ngModel)]="predictiveRecipients"
            name="predictiveRecipients"
            [styleClass]="'advance-inputSwitch'"
            (ngModelChange)="onAutoReplyToggle($event)"
          ></p-inputSwitch>
        </div>
      </div>
      <div class="preferenceInputContainer">
        <label for="from" class="preferenceLabel"
          >Block users from adding external email(s) to Top Contacts
        </label>
        <div class="preferenceswitch">
          <p-inputSwitch
            [(ngModel)]="isEmailSharingBlocked"
            name="isEmailSharingBlocked"
            [styleClass]="'advance-inputSwitch'"
            (ngModelChange)="onAutoReplyToggle($event)"
          ></p-inputSwitch>
        </div>
      </div>
      <div class="preferenceInputContainer">
        <label for="from" class="preferenceLabel"
          >Make Inquiry Source mandatory for resolve
          <span
            ><img
              src='assets/qwyn/icons/secondary-column.svg'
              class="icon-preference"
              (mouseover)="showAddtoGrpPanel($event, info_sub_preferences)"
              alt="Info"
            />
            <p-overlayPanel
              [styleClass]="'icon-preference-submenu1'"
              [appendTo]="'body'"
              #info_sub_preferences
              [baseZIndex]="9999"
            >
              <div class="d-flex flex-row mb-0.3">
                <span class="info-preference-insid">
                  <div
                      class="inqHeading"
                    >
                      Inquiry Source List
                    </div>
                <ul class="inqList">

                    <li style="padding-bottom:7px;list-style-type:disc;">
                      Email
                    </li>
                    <li style="padding-bottom:7px;list-style-type:disc;">
                      Fax
                    </li>
                    <li style="padding-bottom:7px;list-style-type:disc;">
                      Phone
                    </li>
                    <li style="padding-bottom:7px;list-style-type:disc;">
                      Swift
                    </li>
                    <li style="padding-bottom:disc;list-style-type:disc;">
                      Lock
                    </li>
                </ul>
                </span>
              </div>
            </p-overlayPanel></span
          ></label
        >
        <div class="preferenceswitch">
          <p-inputSwitch
            [(ngModel)]="isInquirySourceMandatory"
            name="isInquirySourceMandatory"
            [styleClass]="'advance-inputSwitch'"
            (ngModelChange)="onAutoReplyToggle($event)"
          ></p-inputSwitch>
        </div>
      </div>
      <div class="preferenceInputContainer">
        <label for="from" class=" preferenceLabel"
          >Make External Client ID mandatory for resolve
        </label>
        <div class="preferenceswitch">
          <p-inputSwitch
            [(ngModel)]="isGfidMandatory"
            name="isGfidMandatory"
            [styleClass]="'advance-inputSwitch'"
            (ngModelChange)="onAutoReplyToggle($event)"
          ></p-inputSwitch>
        </div>
      </div>
      <div class="preferenceInputContainer">
        <label for="from" class=" preferenceLabel">
          Add Inquiry reference Id to email response</label
        >
        <div class="preferenceswitch">
          <p-inputSwitch
            [(ngModel)]="isInqReferenceIdReq"
            name="isInqReferenceIdReq"
            [styleClass]="'advance-inputSwitch'"
            (ngModelChange)="onAutoReplyToggle($event)"
          ></p-inputSwitch>
        </div>
      </div>
      <div class="preferenceInputContainer">
        <label for="from" class="preferenceLabel"
          >Exclude My Group While Replying All
        </label>
        <div class="preferenceswitch">
          <p-inputSwitch
            [(ngModel)]="excludeMyGroupWhileReplyAll"
            name="excludeMyGroupWhileReplyAll"
            [styleClass]="'advance-inputSwitch'"
            (ngModelChange)="onAutoReplyToggle($event)"
          ></p-inputSwitch>
        </div>
      </div>
      <!-- C153176-5630 | Enable/disable client contact list visibility for group members. -->
      <div class="preferenceInputContainer">
        <label for="from" class=" preferenceLabel"
          >Hide client contact list</label
        >
        <div class="preferenceswitch">
          <p-inputSwitch
            [(ngModel)]="hideClientList"
            name="hideClientList"
            [styleClass]="'advance-inputSwitch'"
            (ngModelChange)="onAutoReplyToggle($event)"
          ></p-inputSwitch>
        </div>
      </div>
      <!-- C153176-6148 | Group configuration : Re-age need supervisor approval. -->
      <div class="preferenceInputContainer">
        <label for="from" class="preferenceLabel"
          >Disable supervisor approval for Inquiry re age</label
        >
        <div class="preferenceswitch">
          <p-inputSwitch
            [(ngModel)]="supervisiorApprovalForReage"
            name="supervisiorApprovalForReage"
            [styleClass]="'advance-inputSwitch'"
            (ngModelChange)="onAutoReplyToggle($event)"
          ></p-inputSwitch>
        </div>
      </div>
      <!--C170665-10 | Enable Request Type and Root Cause Mapping -->
      <div class="preferenceInputContainer">
        <label for="from" class=" preferenceLabel"
          >Enable Request Type and Root Cause Mapping</label
        >
        <div class="preferenceswitch">
          <p-inputSwitch
            [(ngModel)]="requestTypeRootCauseFilter"
            name="requestTypeRootCauseFilter"
            [styleClass]="'advance-inputSwitch'"
            (ngModelChange)="onAutoReplyToggle($event)"
          ></p-inputSwitch>
        </div>
      </div>
      <div
        *ngIf="displayEnableOrgMetaDataOption"
        class="preferenceInputContainer"
      >
        <label for="from" class="preferenceLabel"
          >Disable Organization Level Meta Data</label
        >
        <div class="preferenceswitch">
          <p-inputSwitch
            [(ngModel)]="enableOrgMetaData"
            name="enableOrgMetaData"
            [styleClass]="'advance-inputSwitch'"
            (ngModelChange)="onAutoReplyToggle($event)"
          ></p-inputSwitch>
        </div>
      </div>
      <!-- [C170665-1719] DCC Requirement: Add Case status field -->
      <div *ngIf="enableInquirySubStatusFlag" class="preferenceInputContainer">
        <label for="from" class=" preferenceLabel">
          Enable Inquiry Sub-Status
        </label>
        <div class="preferenceswitch">
          <p-inputSwitch
            [disabled]="isInquirySubStatusEnabledByOrgAdmin"
            [(ngModel)]="enableInquirySubStatus"
            name='enableInquirySubStatus'
            [styleClass]="'advance-inputSwitch'"
          ></p-inputSwitch>
        </div>
      </div>
      <div class="preferenceInputContainer">
        <label for="from" class=" preferenceLabel">
          Enable work shift and holiday based age calculation
        </label>
        <div class="preferenceswitch">
          <p-inputSwitch
            [(ngModel)]="holidayAndShiftDetails"
            name='holidayAndShiftDetails'
            (onChange)="enableShiftCng()"
            [styleClass]="'advance-inputSwitch'"
          ></p-inputSwitch>
        </div>
      </div>

      <div class="preferenceInputContainer">
        <div *ngIf="workshiftErrMsg" class="error-div">
          <span class="errorMsg">{{workshiftErrMsg}}</span>
        </div>
      </div>
      <div class="d-flex flex-row radio-margin-left">
        <div [hidden]="enableWorkShiftDiv" class="w-100 work-shift-container">
          <div class="preferenceTimeInputContainer">
            <label for="from" class="preferenceTimeLabel">Time zone* </label>
            <div class="w-100 d-flex justify-content-start">
              <p-dropdown
                [styleClass]="'preferenceDropdown drop-down group-details-inp drop-admin'"
                optionLabel="timeZoneName"
                [(ngModel)]="selectedTimeZone"
                name='selectedTimeZone'
                [options]="timeZones"
              >
              </p-dropdown>
            </div>
          </div>
          <div class="preferenceTimeInputContainer">
            <label for="from" class="preferenceTimeLabel">Country* </label>
            <div class="w-100 d-flex justify-content-start">
              <p-dropdown
                [styleClass]="'preferenceDropdown drop-down group-details-inp drop-admin'"
                optionLabel="countryName"
                [(ngModel)]="selectedCountry"
                name='selectedCountry'
                [options]="countryList"
              >
              </p-dropdown>
            </div>
          </div>
          <div class="preferenceTimeInputContainer">
            <label for="from" class="preferenceTimeLabel timeWidth"
              >Non working days
            </label>
            <div class="daySelection" id="nonWorkingDaysCheckboxes">
              <label *ngFor="let day of weekelyOff" class="checkbox-label">
                <input
                  type="checkbox"
                  [value]="day.checked"
                  [checked]="day.checked"
                  (click)="getDaySelection($event,day)"
                />
                {{ day.label }}
              </label>
            </div>
          </div>
          <div class="preferenceTimeInputContainer ">
            <label class=" preferenceTimeLabel timeWidth">Shift time* </label>
            <div class="d-flex">
              <div>
                <label for="from" class=" preferenceTimeStartLabel"
                  >Start*
                </label>
                <p-dropdown
                  [styleClass]="'preferenceDropdownSmall drop-down group-details-inp drop-admin'"
                  optionLabel="value"
                  [placeholder]="'Select start time'"
                  [options]="shifttimeList"
                  [(ngModel)]="selectedStartTime"
                  name='selectedStartTime'
                >
                </p-dropdown>
              </div>
              <div>
                <label class=" preferenceTimeStartLabel">End* </label>
                <p-dropdown
                  [styleClass]="'preferenceDropdownSmall drop-down group-details-inp drop-admin'"
                  optionLabel="value"
                  [placeholder]="'Select end time'"
                  [options]="shifttimeList"
                  [(ngModel)]="selectedEndTime"
                  name='selectedEndTime'
                >
                </p-dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="footer">
          <button
            pButton
            label="Undo"
            class="cancel-button"
            (click)="resetForm()"
          ></button>
          <button
            pButton
            label="Save"
            class="submit-button"
            (click)="saveGroup()"
          ></button>
        </div>
      </div>
    </div>
    <!-- preference ends here -->
    <!-- Bypass Peer Review starts here -->
    <div
      class="peerReviewContainer"
      *ngIf="activeGroupOption==='Bypass Peer Review'"
    >
      <div class="infoArea">
        <div class="infoDescBox" *ngIf="peerReviewInfo">
          <div>
            <img src="assets/Inbox/groupAdminInfo.svg" alt="Add" />
          </div>
          <div class="infoText">
            Groups can exclude certain domains from peer review. Inquiries from
            these domains will not undergo the peer review process. Domain
            examples include: gmail.com
          </div>
          <div
            (click)="togglePeerReviewInfo()"
            pTooltip="Close"
            tooltipPosition="left"
            tooltipStyleClass="leftTooltip p-tooltip-text"
          >
            <img src="assets/Inbox/groupAdminClose.svg" alt="Add" />
          </div>
        </div>
        <div
          *ngIf="!peerReviewInfo"
          class="infoIcon"
          (click)="togglePeerReviewInfo()"
        >
          <img src="assets/Inbox/groupAdminInfo.svg" alt="Add" />
        </div>
      </div>
      <div class="d-flex flex-column" *ngIf="prdData.length !== 0">
          <div class="peerReviewHeader">
            <div><span *ngIf="domainValidationFlag" class="error-info">{{domainMsg}}</span></div>
            <div class='d-flex'>
              <div class="add-new-btn" (click)="addDomain(null, null, 'top')">
                <span class="peerButtons"> + Add New</span>
              </div>
              <div class="buttonDivider" [hidden]="domainDeleteFlag"></div>
              <span [hidden]="domainDeleteFlag">
                <!-- Jira:4703 : Confirmation Dialog before delete -->

                <div class="deleteButton" (click)="setConfirmation('peerReview')">
                  <img class="qma-text" src="assets/Inbox/peerreviewDelete.svg" alt="Delete" />

                  <span class="peerButtons">Delete</span>
                </div>
              </span>
            </div>
          </div>
        <div id="domain" class="peerReviewTable">
          <ag-grid-angular
            #agGrid
            style="width: 100%; height: 380px"
            class="ag-theme-balham peerTable"
            [columnDefs]="prdColumn"
            [rowData]="prdData"
            (selectionChanged)="onDomainCheck()"
            [defaultColDef]="domainCheckbox"
            [singleClickEdit]="true"
            [rowSelection]="rowSelection"
            [stopEditingWhenCellsLoseFocus]="true"
            [suppressRowClickSelection]="true"
            (gridReady)="onGridReady($event)"
            (cellValueChanged)="onCellValueTxt($event)"
            [rowHeight]="32"
            [headerHeight]="44"
            [suppressHorizontalScroll]="true"
          ></ag-grid-angular>
        </div>
        <div class="footer">
          <button
            pButton
            label="Undo"
            class="cancel-button"
            (click)="resetForm()"
          ></button>
          <button
            pButton
            label="Save"
            class="submit-button"
            (click)="saveGroup()"
          ></button>
        </div>
      </div>
      <div *ngIf="prdData.length === 0" class="noPeerReview">
        <img src="assets/Inbox/peerReviewGradient.svg" alt="Info" />
        <div class="noPeerReviewTextBox">
          <div class="noPeerReviewText">No Domains set up yet.</div>
          <div class="noPeerReviewText">
            Please select “Add New” to add a new Domain.
          </div>
          <div class="addButton" (click)="addDomain(null, null, 'top')">
            Add New
          </div>
        </div>
      </div>
    </div>
    <!-- Bypass Peer Review ends here -->
    <!-- client category starts here -->
    <div
      class="peerReviewContainer"
      [style.display]="activeGroupOption === 'Client Category' ? 'block' : 'none'"
    >
      <div class="infoArea">
        <div class="infoDescBox" *ngIf="peerReviewInfo">
          <div>
            <img src="assets/Inbox/groupAdminInfo.svg" alt="Add" />
          </div>
          <div class="infoText">
            {{infoClientCat}}
          </div>
          <div
            (click)="togglePeerReviewInfo()"
            pTooltip="Close"
            tooltipPosition="left"
            tooltipStyleClass="leftTooltip p-tooltip-text"
          >
            <img src="assets/Inbox/groupAdminClose.svg" alt="Add" />
          </div>
        </div>
        <div
          *ngIf="!peerReviewInfo"
          class="infoIcon"
          (click)="togglePeerReviewInfo()"
        >
          <img src="assets/Inbox/groupAdminInfo.svg" alt="Add" />
        </div>
      </div>
      <div
        class="d-flex flex-column customCategoryContainer"

      >

        <span
          *ngIf="domainValidationFlag"
          style="color: red;"
          >{{domainMsg}}</span
        >
        <div>
          <div class="d-flex flex-row"><span>*Platinum, Priority and Client are default categories; the
            color codes for these three categories cannot be maintained from this screen.</span>
          </div>
          <!--C153176-4566 | Show the system default categories - Starts-->
          <div class="d-flex flex-row align-items-center">
              <ng-template ngFor let-category [ngForOf]="clientCategories" let-idx="index">
                  <span>{{category.categoryName}}</span>
                  <span class="clientCategory" [style.backgroundColor]="category.colorCode"> </span>
                  <span class="me-1" *ngIf="idx != clientCategories.length-1">,</span>
              </ng-template>
          </div>
        </div>
        <div class="peerReviewHeader justify-content-end mt-4">
          <!-- <div class="add-new-btn" (click)="onAddCustomCategory()">
            <span class="peerButtons"> + Add New</span>
          </div>
          <div class="buttonDivider" [hidden]="categoryDeleteFlag"></div> -->
          <span [hidden]="categoryDeleteFlag">
            <!-- Jira:4703 : Confirmation Dialog before delete -->

            <div class="deleteButton" (click)="setConfirmation('clientCategory')">
              <img
                class="qma-text"
                src="assets/Inbox/peerreviewDelete.svg"
                alt="Delete"
              />

              <span class="peerButtons">Delete</span>
            </div>
          </span>
        </div>


        <div id="domain" class="peerReviewTable">
          <ag-grid-angular
            #agGrid
            style="width: 100%; height: 109px"
            class="ag-theme-balham peerTable"
            [rowData]="clientCategoryRowData"
            [columnDefs]="clientCategoryColumnDefs"
            (selectionChanged)="onCategoryCheck()"
            [defaultColDef]=""
            [singleClickEdit]="true"
            [rowSelection]="rowSelection"
            [stopEditingWhenCellsLoseFocus]="true"
            [suppressRowClickSelection]="true"
            (gridReady)="onGridReadyClient($event)"
            (cellValueChanged)="onCellValueChangedClient($event)"
            [rowHeight]="32"
            [headerHeight]="44"
            [suppressHorizontalScroll]="true"
          >
          </ag-grid-angular>
          <span *ngIf="ClientNameValidation" class="clientValidationSpan">
            {{ ClientNameValidation }}
          </span>
        </div>
        <div class="footer">
          <button
            pButton
            label="Undo"
            class="cancel-button"
            (click)="resetForm()"
          ></button>
          <button
            pButton
            label="Save"
            class="submit-button"
            (click)="saveGroup()"
          ></button>
        </div>
      </div>
      <!-- <div *ngIf="clientCategoryRowData.length === 0" class="noPeerReview">
        <img src="assets/Inbox/peerReviewGradient.svg" alt="Info" />
        <div class="noPeerReviewTextBox">
          <div class="noPeerReviewText">No Client Categories set up yet.</div>
          <div class="noPeerReviewText">
            Please select “Add New” to start setting categories.
          </div>
          <div class="addButton" (click)="onAddCustomCategory()">Add New</div>
        </div>
      </div> -->
      <p-dialog
        [(visible)]="errorMessage"
        [modal]="true"
        [responsive]="true"
        [maximizable]="false"
        [appendTo]="'body'"
        [styleClass]="'contextMenuModal errorModal ModelClose'"
        [closable]="true"
        [dismissableMask]="true"
        [baseZIndex]="10000"
        [closeOnEscape]="true"
        [style]="{width: '30%'}"
      >
        <p-header>
          <div
            class="d-flex flex-row align-items-center justify-content-between"
          >
            <h6 class="success-title">Error Message</h6>
            <!-- <button type="button" (click)="closeErrorModal()" class="d-flex flex-row close qma-text">
              <img src="assets/Inbox/close_icon_u73.svg">
              <h6>CLOSE</h6>
          </button> -->
          </div>
        </p-header>
        <div class="success-msg">{{errorMessageForClientCategory}}</div>
      </p-dialog>
    </div>
    <!-- client category ends here -->
    <!-- inquiry rules starts here -->
    <div
      class="peerReviewContainer"
      *ngIf="activeGroupOption==='Inquiry Rules'"
    >
      <div class="infoArea">
        <div class="infoDescBox" *ngIf="peerReviewInfo">
          <div>
            <img src="assets/Inbox/groupAdminInfo.svg" alt="Add" />
          </div>
          <div class="infoText">
            Groups can exclude certain domains from peer review. Inquiries from
            these domains will not undergo the peer review process. Domain
            examples include: gmail.com
          </div>
          <div
            (click)="togglePeerReviewInfo()"
            pTooltip="Close"
            tooltipPosition="left"
            tooltipStyleClass="leftTooltip p-tooltip-text"
          >
            <img src="assets/Inbox/groupAdminClose.svg" alt="Add" />
          </div>
        </div>
        <div
          *ngIf="!peerReviewInfo"
          class="infoIcon"
          (click)="togglePeerReviewInfo()"
        >
          <img src="assets/Inbox/groupAdminInfo.svg" alt="Add" />
        </div>
      </div>
      <div class="inquiryRulesBox">
        <!-- <h6 style="color:#002D72">INQUIRY RULES</h6>
          <div style="text-align:right">
              <img src="assets/Inbox/info-icon.svg" class="icon-setting-out"
                  (mouseover)="showAddtoGrpPanel($event, info_inquiry_rules)"
                  (mouseout)="info_inquiry_rules.hide()" alt="Info">
              <p-overlayPanel [styleClass]="'icon-info inquiry-rules-icon-info'" [appendTo]="'body'"
                  #info_inquiry_rules [baseZIndex]="9999">
                  <div class="d-flex flex-row mb-0.3">
                      <span>
                          <img class="qma-text icon-setting-in" src="assets/Inbox/info-icon.svg"
                              alt="Info">
                      </span>
                      <span
                          class="info-content">{{infoInquiryRules}}<br /><b>{{infoInquiryRulesExtTitle}}</b>{{infoInquiryRulesExt}}</span>
                  </div>
              </p-overlayPanel>
          </div>

          <div class="mt-4">
              <span class="disclaimer">{{ruleDisclaimer}}</span>
          </div> -->
        <div class="inquiryRulesAction">
          <div class="inquiryRulesLeft">
            <div (click)="uploadInquiry()"  class="downloadUploadbutton">
              <img
                class="default-icon"
                src="assets/context/groupadminUpload.svg"
              />Bulk Upload
            </div>
            <input name="files" id="files" type="file" multiple="false" style="display:none"
                      #uploadFilesForInquiry (change)="fileEventForInquiry($event)" accept=".xlsx"
                      value="" />
            <div class="buttonDivider"></div>
            <div (click)="download_rules()" class="inquiryDownload">
              <img
                [src]="'assets/Inbox/downloadBlack.svg'"
                class="default-icon"
              />Download Form
            </div>
          </div>
          <div class="inquiryRulesRight"  *ngIf="(this.routesList.length > 0 || !isSaved)">
            <div class="inquiryRulesButton"
            pTooltip="Quick search"
              tooltipPosition="top"
              tooltipStyleClass="leftTooltip ui-tooltip-text"
            (click)="filterIconClick()" [hidden]="filterIconHide" [ngClass]="{'hide':filterIconHide}">
              <img src="assets/context/groupadminSearch.svg" />
            </div>
            <div class="inbox-input" [hidden]="!filterIconHide" [ngClass]="{'hide':!filterIconHide}">
              <input class="inbox-filter-txtbox" type="text" placeholder="Filter..."
                  (keyup)="onKey($event)" [(ngModel)]="filterText" name='filterText'/>
              <img src="assets/Inbox/close_icon_u73.svg" width=12 (click)="filterCloseClick()"
                  class="mail-box-filter-close-img ms-2" alt="Close" />
          </div>
            <div class="iconButtonDivider"></div>
            <div
            pTooltip="Add new rules"
            tooltipPosition="top"
            tooltipStyleClass="leftTooltip ui-tooltip-text"
              class="inquiryRulesButton"
              (click)="addRules(null, null, 'top')"
            >
              <img src="assets/context/groupadminAdd.svg" />
            </div>
            <div class="iconButtonDivider"></div>
            <div class="inquiryRulesButton"
              pTooltip="Make a copy"
              tooltipPosition="top"
              tooltipStyleClass="leftTooltip ui-tooltip-text"
              (click)="copyInquiryRecords()">
              <img src="assets/context/groupadminCopy.svg" />
            </div>
            <div class="iconButtonDivider"></div>
            <div
              class="inquiryRulesButton"
              pTooltip="Check duplicate"
              tooltipPosition="top"
              tooltipStyleClass="leftTooltip ui-tooltip-text"
              (click)="checkDuplicate($event)"
            >
              <img src="assets/context/groupadminDuplicate.svg" />
            </div>
            <div class="iconButtonDivider"></div>
            <div
              class="inquiryRulesButton"
              pTooltip="Restore Inquiry Rules"
              tooltipPosition="top"
              tooltipStyleClass="leftTooltip ui-tooltip-text"
              (click)="restoreRulesShowPopUp($event)"
            >
              <img src="assets/context/groupadminRefresh.svg" />
            </div>
            <div class="iconButtonDivider"></div>
            <div
              class="inquiryRulesButton"
              pTooltip="Delete"
              tooltipPosition="top"
              tooltipStyleClass="leftTooltip ui-tooltip-text"
              (click)="setConfirmation('inquiryRules')"
            >
              <img src="assets/context/groupadminDelete.svg" />
            </div>
          </div>
        </div>
        <!-- <div class="d-flex align-items-center w-100 py-2">
              <span class="inbox-options-item inbox-search-option " [ngClass]="{'hide':filterIconHide}">
                  <img class="inbox-search-option" src='assets/Inbox/search_icon_selected_u42.svg'
                      alt='Kiwi standing on oval' (click)="filterIconClick()">
              </span>
              <div class="inbox-input" [ngClass]="{'hide':!filterIconHide}">
                  <input class="inbox-filter-txtbox" type="text" placeholder="Filter..."
                      (keyup)="onKey($event)" [(ngModel)]="filterText" />
                  <img src="assets/Inbox/close_icon_u73.svg" width=25 (click)="filterCloseClick()"
                      class="mail-box-filter-close-img" alt="Close" />
              </div>
              <div class="d-flex justify-content-start" style="width: 60%;">
                  <span class="me-9" style="width:18%;">
                      <div class="add-new-btn" (click)="addRules(null, null, 'top')">
                          <span style="text-decoration: none; display: inline-block;padding-right:3px;">
                              <img class="qma-text" style="height:13px;width:13px;opacity:2;"
                                  src="assets/context/add-button.svg" alt="Add">
                          </span>
                          <span>Add new rule</span>
                      </div>
                  </span>
                  <span style="width:11%">
                      <span class="add-new-btn" (click)="setConfirmation('inquiryRules')">
                          <span style="text-decoration: none; display: inline-block;">
                              <img style="width:11px;height:11px;" class="qma-text"
                                  src="assets/context/delete-button.svg" alt="Delete">
                          </span>Delete
                      </span>

                  </span>
                  <span class="me-9" style="width:16%;">
                      <div class="add-new-btn" (click)="copyInquiryRecords()">
                          <span style="text-decoration: none; display: inline-block;padding-right:3px;">
                              <img class="qma-text" style="height:13px;width:13px;opacity:2;"
                                  src="assets/Inbox/copy_icon.svg" alt="Copy">
                          </span>
                          <span>Make a copy</span>
                      </div>
                  </span>
                  <span class="me-9" style="width:22%;">
                      <div class="add-new-btn" (click)="checkDuplicate($event, duplicate)">
                          <span style="text-decoration: none; display: inline-block;padding-right:3px;">
                              <img class="qma-text" style="height:13px;width:13px;opacity:2;"
                                  src="assets/context/add-button.svg" alt="Add">
                          </span>
                          <span>Check duplicates</span>
                      </div>
                  </span>
                  <span class="me-9" style="width:33%;">
                      <div class="add-new-btn" *ngIf="true"
                          (click)="restoreRulesShowPopUp($event, restoreRules)">
                          <span style="text-decoration: none; display: inline-block;padding-right:3px;">
                              <img class="qma-text" style="height:13px;width:13px;opacity:2;"
                                  src="assets/context/restore-rules.svg" alt="Restore">
                          </span>
                          <span>Restore rules</span>
                      </div>
                  </span>
              </div>
              <div class="d-flex justify-content-end" style="width: 32%;text-align: right">
                  <span class="me-9" style="width:39%;">
                      <div class="add-new-btn" (click)="uploadInquiry()">
                          <span style="text-decoration: none; display: inline-block;padding-right:3px;">
                              <img class="qma-text"
                                  style="height:13px;width:13px;opacity:2;transform: rotate(180deg);"
                                  src="assets/Inbox/download_icon_u70.svg" alt="Upload">
                          </span>
                          <span>Upload</span>
                      </div>
                  </span>
                  <input name="files" id="files" type="file" multiple="false" style="display:none"
                      #uploadFilesForInquiry (change)="fileEventForInquiry($event)" accept=".xlsx"
                      value="" />

                  <span class="me-9" style="width:27%;">
                      <div class="add-new-btn" (click)="download_rules()">
                          <span style="text-decoration: none; display: inline-block;padding-right:3px;">
                              <img class="qma-text" style="height:13px;width:13px;opacity:2;"
                                  src="assets/Inbox/download_icon_u70.svg" alt="Download">
                          </span>
                          <span>Download</span>
                      </div>
                  </span>
              </div>
              <span class="me-9" *ngIf="invalidRowMessage.length > 0">
                  <div class="add-new-btn" (click)="onDownloadLogs()">
                      <span style="text-decoration: none; display: inline-block;padding-right:3px;">
                          <img class="qma-text" style="height:13px;width:13px;opacity:2;"
                              src="assets/Inbox/download_icon_u70.svg" alt="Download">
                      </span>
                      <span>Download failed rules</span>
                  </div>
              </span>
          </div> -->
        <div *ngIf="(this.routesList.length > 0 || !isSaved)">
          <div
            *ngIf="!this.validationCheckForAction || !this.validationCheckForEmpty"
          >
            <span class="errorMsg">{{validationRules}}</span>
          </div>

          <div class="d-flex flex-row mt-4">
            <ag-grid-angular
              #inquiryGrid
              style="width: 100%; height: 430px"
              class="ag-theme-balham peerTable inquiryTable"
              [rowData]="routesList"
              [columnDefs]="routesColumn"
              [stopEditingWhenCellsLoseFocus]="true"
              [suppressRowClickSelection]="true"
              [pagination]="true"
              [defaultColDef]="inquiryRulesChecbox"
              [singleClickEdit]="true"
              [rowSelection]="rowSelection"
              [paginationPageSize]="100"
              (gridReady)="onGridReadyInquiry($event)"
              (paginationChanged)="onPaginationChanged()"
              (selectionChanged)="onSelectionRules()"
              [suppressPaginationPanel]="true"
              [suppressMenuHide]="true"
              [suppressDragLeaveHidesColumns]="true"
              [suppressMakeColumnVisibleAfterUnGroup]="true"
              [suppressColumnVirtualisation]="true"
              [rowHeight]="32"
              [headerHeight]="44"
            >
            </ag-grid-angular>
          </div>
          <p-overlayPanel
            [styleClass]="'duplicate_panel duplicate_overlay duplicateOverlay'"
            class="duplicateOverlay"
            [appendTo]="'body'"
            [dismissable]="true"
            #duplicate
            [baseZIndex]="9999"
          >
          <p-header>
            <div class="d-flex flex-row align-items-center p-2 pt-3 px-3 justify-content-between duplicates-header">
              <h6 class="reage-title">Duplicate Inquiries</h6>
              <div type="button" (click)="hideDuplicateModal(duplicate)" class="d-flex flex-row qma-text">
                <img height="14px" width="14px" src="assets/qwyn/icons/close.svg" alt="Close" />
              </div>
            </div>
          </p-header>
            <!-- <p-header>
              <div
                class="d-flex flex-row align-items-center justify-content-between"
              >
                <div class="d-flex justify-content-start" style="width:80%">
                  <div style="width:16%">
                    <h6 class="new-rule">NEW RULES</h6>
                  </div>
                  <div style="width:84%">
                    <h6 class="duplicate-rule">DUPLICATES</h6>
                  </div>
                </div>
                <div class="d-flex justify-content-end" style="width:20%">
                  <button
                    type="button"
                    (click)="hideDuplicateModal(duplicate)"
                    class="d-flex flex-row close qma-text"
                    style="border:none !important;opacity:1"
                  >
                    <img src="assets/Inbox/close_icon_u73.svg" alt="Close" />
                    <h6>CLOSE</h6>
                  </button>
                </div>
              </div>
            </p-header> -->


            <div class="d-flex flex-row ">
              <ag-grid-angular
                #inquiryGridDuplicate
                style="width: 100%; height: 270px;"
                class="ag-theme-balham peerTable inquiryTable"
                id="inquiryRulesGridDuplicate"
                [rowData]="duplicateList"
                [columnDefs]="duplicateColumn"
                [stopEditingWhenCellsLoseFocus]="true"
                [suppressRowClickSelection]="true"
                [pagination]="true"
                [defaultColDef]="duplicateCheckBox"
                [singleClickEdit]="true"
                [rowSelection]="rowSelection"
                [paginationPageSize]="100"
                (gridReady)="onGridDuplicate($event)"
                suppressPaginationPanel="true"
                (paginationChanged)="onPaginationChanged()"
                (selectionChanged)="onSelectionRules()"
                [suppressDragLeaveHidesColumns]="true"
                suppressMenu="true"
                [rowHeight]="32"
                [headerHeight]="44"
                [suppressHorizontalScroll]="false"
                (rowDataChanged)="dupGridRowDataChanged($event)"
              >
                <!-- C153176-4453-->
              </ag-grid-angular>
            </div>
          </p-overlayPanel>
          <p-overlayPanel
            [styleClass]="'inq-rules-restore-overlay'"
            [appendTo]="'body'"
            style="display: none;"
            [hidden]="true"
            [dismissable]="false"
            #restoreRules
            [baseZIndex]="9999"
          >
            <p-header>
              <div class="inq-rules-restore-header-container">
                <span class="qma-inq-rule-popup-header"
                  >Restore Inquiry Rules</span
                >

              </div>
            </p-header>
            <div *ngIf="restoreStatus" class="inq-restore-content mt-2">
            </div>
            <div *ngIf="!restoreStatus" class="inq-restore-content">
              <div>There are no rules to be restored</div>
            </div>
            <p-footer>
              <div class="d-flex flex-row footer-btn-container mt-2"></div>
              <div
                class="d-flex flex-row flex-wrap bottom-button-holder pt-2 justify-content-end"
              >
                <button
                  type="submit"
                  class="btn submit-button me-4 btn-sm"
                  [disabled]="!restoreStatus"
                  (click)="restoreRule($event, restoreRules)"
                >
                  Restore
                </button>
                <button
                  class="btn clear-btn"
                  (click)="cancelRestorePopup($event, restoreRules)"
                >
                  Cancel
                </button>
              </div>
            </p-footer>
          </p-overlayPanel>


          <p-dialog
            [(visible)]="showRestorePopup"
            [modal]="true"
            [responsive]="true"
            [maximizable]="false"
            [appendTo]="'body'"
            [styleClass]="'confirmation-modal'"
            [closable]="false"
            [dismissableMask]="true"
            [baseZIndex]="10000"
            [closeOnEscape]="true"
            [style]="{'max-width':'550px','width':'60%'}">
            <p-header>
              <div class="d-flex flex-row align-items-center justify-content-between confirmation-header">
                <h6 class="reage-title">Restore Inquiry Rules</h6>
                <button type="button" (click)="cancelRestorePopup()" class="d-flex flex-row close qma-text">
                  <img src="assets/Inbox/close_icon_u73.svg" alt="Close" />
                </button>
              </div>
            </p-header>
            <div class="d-flex flex-row align-items-center confirmation-content">
              <div>
                <label> The inquiry rules will be restored to the version saved last on </label>
                <div class="d-flex flex-row align-items-center justify-content-center">{{restoreInquiryDate}}</div>
                <div class="d-flex flex-row align-items-center justify-content-center mt-3">Are you sure you want to go head with the restore? </div>
              </div>
            </div>
            <p-footer>
              <div class="d-flex flex-row flex-wrap align-items-center justify-content-center confirmation-footer">
                <button type="reset" class="btn clear-btn" (click)="cancelRestorePopup()">Cancel</button>
                <button class="btn search-btn" (click)="restoreRule()">Confirm</button>
              </div>
            </p-footer>
          </p-dialog>

          <div
            style="height:40px!important"
            class="inquiryRulesTableBottom qma-mailbox-pagination-container"
          >
            <div class="d-flex align-items-center">
              <span>
                <img
                  [ngClass]="{'pagination-img-disabled':disablePaginationPrevFirst}"
                  (click)="onBtFirst()"
                  id="btFirst"
                  class="pagination-img"
                  src="assets/Inbox/lineLeftButton.svg"
                  alt="First"
                  style="margin-right: 10px;"
                />
              </span>
              <span class="separator-right">
                <img
                  id="btPrevious"
                  [ngClass]="{'pagination-img-disabled':disablePaginationPrevFirst}"
                  (click)="onBtPrevious()"
                  class="pagination-img"
                  src="assets/Inbox/leftButton.svg"
                  alt="Previous"
                />
              </span>

              <span
                id="lbCurrentPage"
                class="separator-right pagination-text-padding inquiryPageNo"
                >{{lbCurrentPage}}</span
              >
              <span class="separator-right pagination-text-padding" style="margin-right: 4px;">of</span>
              <span
                id="lbTotalPages"
                class="separator-right pagination-text-padding"
                >{{lbTotalPages}}</span
              >
              <span>
                <img
                  [ngClass]="{'pagination-img-disabled':disablePaginationNextLast}"
                  id="btNext"
                  (click)="onBtNext()"
                  class="pagination-img"
                  src="assets/Inbox/rightButton.svg"
                  alt="Next"
                  style="margin-right: 10px;margin-left: 14px;"
                />
              </span>
              <span class="separator-right">
                <img
                  [ngClass]="{'pagination-img-disabled':disablePaginationNextLast}"
                  id="btLast"
                  (click)="onBtLast()"
                  class="pagination-img"
                  src="assets/Inbox/lineRightButton.svg"
                  alt="Last"
                />
              </span>
            </div>

            <div class="d-flex align-items-center">
              <span
                class="value inquiryRuleTableRulesCountNo"
                id="lbPageSize"
                >{{lbPageSize}}</span
              >
              <span
                class="separator inquiryRuleTableRulesCount"
                style="margin-left: 4px;"
              >
                of
              </span>
              <span
                class="value separator inquiryRuleTableRulesCount"
                id="lbTotalRecords"
                style="margin-left: 4px;"
                >{{lbTotalRecords}}</span
              >
              <span
                class="separator separator-right inquiryRuleTableRulesCount"
                style="margin-left: 4px;"
              >
                Rules
              </span>
            </div>
          </div>
          <div class="inquiryRulesFooter">
            <div class="inquiryRulseNotes">
              *Note: This save will just save the inquiry rules
            </div>
            <div class="footer">
              <button
                pButton
                label="Undo"
                class="cancel-button"
                (click)="resetForm()"
              ></button>
              <button
                pButton
                label="Save"
                class="submit-button"
                (click)="saveInquiryRules()"
              ></button>
            </div>
          </div>
        </div>
        <div *ngIf="(this.routesList.length === 0 && isSaved)" class="noPeerReview">
          <img src="assets/Inbox/peerReviewGradient.svg" alt="Info" />
          <div class="noPeerReviewTextBox">
            <div class="noPeerReviewText">No Inquiry Rules set up yet.</div>
            <div class="noPeerReviewText">
              Please select “Add New” or Download Form to Bulk Upload.
            </div>

            <div class="addButton" (click)="addRules(null, null, 'top')">
              Add New
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- inquiry rules ends here -->
    <!-- email discliamer -->
    <div
      [style.display]="activeGroupOption === 'Email Disclaimer' ? 'block' : 'none'"
    >
    <div class="infoArea">
      <div class="infoDescBox" *ngIf="emailDisclaimerlInfo">
          <div>
              <img src="assets/Inbox/groupAdminInfo.svg" alt="Add" />
          </div>
          <div class="infoText" [innerHTML]="infoEmailDisclaimer">
          </div>
          <div
              (click)="toggleEmailDisclaimerlInfo()"
              pTooltip="Close"
              tooltipPosition="left"
              tooltipStyleClass="leftTooltip p-tooltip-text">
              <img src="assets/Inbox/groupAdminClose.svg" alt="Add" />
          </div>
      </div>
      <div
          *ngIf="!emailDisclaimerlInfo"
          class="infoIcon"
          (click)="toggleEmailDisclaimerlInfo()">
          <img src="assets/Inbox/groupAdminInfo.svg" alt="Add" />
      </div>
  </div>

      <div style="margin-top:2em;">
        <div class="signatureEditSection" style="margin-left:42px;">
          <div class="d-flex flex-row mt-2 outOfOffice">
            <editor-app [elementId]="'emailDisc'" [toolbarOptions]="2" [height]="300" [fromNewMessage]="true"  class="my-editor"></editor-app>
          </div>
        </div>

        <!-- <div style="margin: 3em 5em;">
          <editor-app [elementId]="'emailDisc'" [ngClass]="isFormatOpen ? '': 'hideToolbar'" [height]="300"></editor-app>

        </div> -->

        <div class="metadata-footer">
          <button pButton label="Undo" class="cancel-button" (click)="resetForm()"></button>
          <button pButton label="Save" class="submit-button" (click)="saveGroup()"></button>
        </div>
      </div>
    </div>
    <!-- automated response -->
    <div [style.display]="activeGroupOption === 'Automated Response' ? 'block' : 'none'">
        <div class="infoArea" style="height:60px">
            <div class="infoDescBox" *ngIf="autoResponseInfo">
                <div>
                    <img src="assets/Inbox/groupAdminInfo.svg" alt="Add" />
                </div>
                <div class="infoText" [innerHTML]="infoAutoResponse">
                </div>
                <div
                    (click)="toggleAutoResponseInfo()"
                    pTooltip="Close"
                    tooltipPosition="left"
                    tooltipStyleClass="leftTooltip p-tooltip-text">
                    <img src="assets/Inbox/groupAdminClose.svg" alt="Add" />
                </div>
            </div>
            <div
                *ngIf="!autoResponseInfo"
                class="infoIcon"
                (click)="toggleAutoResponseInfo()">
                <img src="assets/Inbox/groupAdminInfo.svg" alt="Add" />
            </div>
        </div>

        <div [hidden]="autoResFlagUI" style="margin-left:3em;">
            <div class="w-20 d-flex flex-row" style="margin-top:0px;">
                <div class="preferenceInputContainer">
                    <div style="display: flex; flex-direction: column;">
                        <span style="display: flex; align-items: center; margin-bottom: 0.5em;">
                            <p class="automatedSwitchLabel">Enable Automated Client Acknowledgement</p>
                            <p-inputSwitch
                                    [(ngModel)]="enableAutCliAck"
                                    name='enableAutCliAck'
                                    (ngModelChange)="onToggleClientAck($event)"
                                    [styleClass]="'advance-inputSwitch'">
                            </p-inputSwitch>
                        </span>
                        <span style="display: flex; align-items: center; margin-top: 0.5em;">
                            <p class="automatedSwitchLabel">Enable Automated Response For Internal Users</p>
                            <p-inputSwitch
                                    [(ngModel)]="isAutoResponseEnabledForInternalDomain"
                                    name='isAutoResponseEnabledForInternalDomain'
                                    (ngModelChange)="onToggleClientAck($event)"
                                    [styleClass]="'advance-inputSwitch'">
                            </p-inputSwitch>
                        </span>
                    </div>
                </div>
            </div>

          <div class="automatedHeadingWrap">
            <div class="d-flex flex-row mt-4" [hidden]="!enableAutCliAck && !isAutoResponseEnabledForInternalDomain">
              <label for="from" class="preferenceLabel" style="padding-left: 0px; font-weight:700;">Automated Response</label>
            </div>
            <div class="editButtonWrap" [hidden]="!enableAutCliAck && !isAutoResponseEnabledForInternalDomain">
              <div class="editButton" [ngClass]="{
                            'editButton': autoResponseEdit,
                            'activeEditButton': !autoResponseEdit,
                          }" (click)="editAutoResponse()">
                <img *ngIf="autoResponseEdit" src="assets/qwyn/icons/editBlue.svg" alt="Edit" />
                <img *ngIf="!autoResponseEdit" src="assets/newMessage/messageCloseIcon.svg" alt="Close Edit" class="pr-1" />
                {{ autoResponseEdit ? 'Edit' : 'Close Edit' }}
              </div>
            </div>
          </div>
            <div class="signatureEditSection" [hidden]="!enableAutCliAck && !isAutoResponseEnabledForInternalDomain">
              <div *ngIf="activeGroupOption === 'Automated Response'" class="d-flex flex-row mt-2 outOfOffice" >
                <editor-app [elementId]="'autoResponse'"  [toolbarOptions]="2" [fromAdminAutoResponse]="true" [fromNewMessage]="true"  [height]="340" class="my-editor" [disabled]="autoResponseEdit" [content]="autoResponse" [fromComponent]="'autoResponse'"></editor-app>
              </div>
              <div class="signatureEditButtonSection">
                <div class="signatureEditButton">
                    <input
                        type="checkbox"
                        id="includeAssignedUserInfo"
                        class="customCheckbox"
                        name="includeAssignedUserInfo"
                        [(ngModel)]="includeAssignedUserInfo"
                        [disabled]="autoResponseEdit"
                        (change)="autoResponseCheckboxChange()">
                    <label for="includeAssignedUserInfo" class="signatureEditButtonLabel">
                        Include Assigned User Info
                    </label>
                </div>

                <div class="signatureDivider"></div>

                <div class="signatureEditButton">
                    <input
                        type="checkbox"
                        id="includeUserContactInfo"
                        class="customCheckbox"
                        name="includeUserContactInfo"
                        [(ngModel)]="includeUserContactInfo"
                        [disabled]="autoResponseEdit"
                        (change)="autoResponseCheckboxChange()">
                    <label for="includeUserContactInfo" class="signatureEditButtonLabel">
                        Include User Contact Info
                    </label>
                </div>

                <div class="signatureDivider"></div>

                <div class="signatureEditButton">
                    <input
                        type="checkbox"
                        id="includeManagerContactInfo"
                        class="customCheckbox"
                        name="includeManagerContactInfo"
                        [(ngModel)]="includeManagerContactInfo"
                        [disabled]="autoResponseEdit"
                        (change)="autoResponseCheckboxChange()">
                    <label for="includeManagerContactInfo" class="signatureEditButtonLabel">
                        Include Manager’s Contact Info
                    </label>
                </div>
            </div>


            </div>
            <div *ngIf="!enableAutCliAck && !isAutoResponseEnabledForInternalDomain" style="height:420px;"></div>
            <div class="metadata-footer">
              <button pButton label="Undo" class="cancel-button" (click)="resetForm()"></button>
              <!-- <button pButton label="Preview" class="preview-button" (click)="previewMail()"></button> -->
              <button pButton label="Save" class="submit-button"  (click)="saveGroup()"></button>
              <!-- [ngClass]="{
                'submit-button': !autoResponseEdit,
                'disabled-submit-button': autoResponseEdit,
              }" -->
              <!-- QMA-1568 -->
            </div>
        </div>

    </div>
  </div>
  <p-dialog
    [(visible)]="showPopUpDelete"
    [modal]="true"
    [responsive]="true"
    [maximizable]="false"
    [appendTo]="'body'"
    [styleClass]="'confirmation-modal'"
    [closable]="false"
    [dismissableMask]="true"
    [baseZIndex]="10000"
    [closeOnEscape]="true"
    [style]="{'max-width':'450px','width':'50%'}">
    <p-header>
      <div class="d-flex flex-row align-items-center justify-content-between confirmation-header">
        <h6 class="reage-title">Confirm Action</h6>
        <button type="button" (click)="onCancel()" class="d-flex flex-row close qma-text">
          <img src="assets/Inbox/close_icon_u73.svg" alt="Close" />
        </button>
      </div>
    </p-header>
    <div class="d-flex flex-row align-items-center confirmation-content">
    <label>{{confirmMsgText}}</label>
    </div>
    <p-footer>
      <div class="d-flex flex-row flex-wrap align-items-center justify-content-center confirmation-footer">
        <button type="reset" class="btn clear-btn" (click)="onCancel()">Cancel</button>
        <button class="btn search-btn" (click)="onOk()">Confirm</button>
      </div>
    </p-footer>
  </p-dialog>
</div>
<p-dialog [(visible)]="displaySuccess" [modal]="true" [responsive]="true" [maximizable]="false" [appendTo]="'body'"
    [styleClass]="'contextMenuModal successModal ModelClose'" [closable]="true" [dismissableMask]="true"
    [baseZIndex]="10000" [closeOnEscape]="true" [style]="{width: '30%'}">
    <p-header>
        <div class="d-flex flex-row align-items-center justify-content-between">
            <h6 class="success-title">Success Confirmation</h6>
        </div>
    </p-header>
    <div class="success-msg"> Inquiry rules have been saved successfully</div>
</p-dialog>
<p-dialog [(visible)]="isTabswitchWithoutSave" [modal]="true" [responsive]="true" [maximizable]="false"
  [appendTo]="'body'" [styleClass]="'confirmation-modal'" [closable]="false" [dismissableMask]="true"
  [baseZIndex]="10000" [closeOnEscape]="true" [style]="{'max-width':'450px','width':'50%'}">
  <p-header>
    <div class="d-flex flex-row align-items-center justify-content-between confirmation-header">
      <h6 class="reage-title">Confirm Action</h6>
      <button type="button" (click)="onCancelConfirmation()" class="d-flex flex-row close qma-text">
        <img src="assets/Inbox/close_icon_u73.svg" alt="Close" />
      </button>
    </div>
  </p-header>
  <div class="d-flex flex-row align-items-center confirmation-content">
    <span>{{confirmSwitchTabMsg}}</span>
  </div>
  <p-footer>
    <div class="d-flex flex-row flex-wrap align-items-center justify-content-center confirmation-footer">
      <button type="reset" class="btn clear-btn" (click)="resetForm()">Discard</button>
      <button class="btn search-btn" (click)="saveGroup()">Save</button>
    </div>
  </p-footer>
</p-dialog>